module.exports = __webpack_public_path__ + "img/c39.35743d32.gif";